var _defs, _rect, _use, _use2, _polygon, _polygon2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg24FlagUk(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "26px",
    height: "13px",
    viewBox: "0 0 26 13",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "WhiteStripe",
    fill: "#FFFFFF",
    width: 30,
    height: 2.6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "RedStripe",
    fill: "#CF142B",
    width: 15,
    height: 0.8666666666666667
  }), /*#__PURE__*/React.createElement("g", {
    id: "Stripe"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#WhiteStripe",
    x: 0,
    y: 0
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#RedStripe",
    x: 0,
    y: 1.3
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#RedStripe",
    x: 15,
    y: 0.4333333333333333
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#00247D",
    width: 26,
    height: 13
  })), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Stripe",
    x: -2,
    y: 5.2,
    transform: "rotate(26.5, 13, 6.5)"
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Stripe",
    x: -2,
    y: 5.2,
    transform: "rotate(-26.5, 13, 6.5)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: " 0,4.333 10.833,4.333 10.833,0 15.167,0 15.167,4.333 26,4.333 26,8.667 15.167,8.667 15.167,13 10.833,13 10.833,8.667 0,8.667 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#CF142B",
    points: " 0,5.2 11.7,5.2 11.7,0 14.3,0 14.3,5.2 26,5.2 26,7.799 14.3,7.799 14.3,13 11.7,13 11.7,7.799 0,7.799 "
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg24FlagUk);
export default __webpack_public_path__ + "static/media/24-flag-uk.6587149804915427f22dfc5c05e8ae5a.svg";
export { ForwardRef as ReactComponent };